import React from "react";
import Navitem from "./Navitem";
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';

const useStyles = makeStyles((theme) => ({
    nav: {
      margin: '10px 0px',
      width: '100%',
    },
    menuButton: {
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    title: {
      position: 'absolute',
      right: theme.spacing(3)
    },
    root: {
      position: 'fixed',
    },
    closeButton: {
      position: 'absolute',
      top: '0',
      right: '0',
    },
    pageTitle: {
       fontWeight: 600,
    }
  }));

export default function ProjectsNav(props) {
  const classes = useStyles();

  return (
    (<Grid 
    container
    direction="row"
    justifyContent="space-between"
    className={classes.nav}>
      {
        props.projectsList.map(
          (projectList) => (
            <Navitem item={projectList.title} tolink={projectList.route} key={projectList.title + "_navItem"}
            icon={<Icon style={projectList.iconStyle} className={projectList.iconClass}/>}/>
          )
        )
      }
    </Grid>)
  );
}